(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["object.symptom-quick-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    const rails = document.querySelectorAll(".o-symptom-quick-filters__pills");

    // Check the user is on desktop
    if (!rails.length || !window.matchMedia("(pointer: fine)").matches) return;

    rails.forEach((rail) => {
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let dragged = false;
      const DRAG_THRESHOLD = 8;
      
      rail.addEventListener("pointerdown", (e) => {
        if (e.pointerType !== "mouse" || e.button !== 0) return; 
        isDragging = true;
        dragged = false;
        startX = e.clientX;
        startScrollLeft = rail.scrollLeft;
      });

      rail.addEventListener("pointermove", (e) => {
        if (!isDragging) return;
        const dragX = e.clientX - startX;
        if (Math.abs(dragX) <= DRAG_THRESHOLD) return;
        if (!dragged) {
          dragged = true;
          rail.classList.add("is-dragging");
          // Allow dragging outside of container
          rail.setPointerCapture(e.pointerId);
        }
        rail.scrollLeft = startScrollLeft - dragX;
      });

      const endDrag = (e) => {
        if (!isDragging) return;
        isDragging = false;
        rail.classList.remove("is-dragging");
        if (rail.hasPointerCapture(e.pointerId)) {
          rail.releasePointerCapture(e.pointerId);
        }
      };

      rail.addEventListener("pointerup", endDrag);
      rail.addEventListener("pointercancel", endDrag);

      rail.addEventListener(
        "click",
        (e) => {
          if (!dragged) return;
          // e.preventDefault();
          // e.stopPropagation();
          dragged = false;
        },
        true
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
